var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import { IconButton, Tooltip, useTheme, alpha, } from "@mui/material";
export const SIconButton = (_a) => {
    var { children, colorVariant = "primary", title, showBackground = true, alphaValue = 0.08, sx } = _a, props = __rest(_a, ["children", "colorVariant", "title", "showBackground", "alphaValue", "sx"]);
    const theme = useTheme();
    // Get the main color from theme palette for background
    const getMainColorFromVariant = (variant) => {
        switch (variant) {
            case "primary":
                return theme.palette.primary.main;
            case "inherit":
                return theme.palette.grey[800];
            case "secondary":
                return theme.palette.secondary.main;
            case "error":
                return theme.palette.error.main;
            case "warning":
                return theme.palette.warning.main;
            case "info":
                return theme.palette.info.main;
            case "success":
                return theme.palette.success.main;
            default:
                return theme.palette.primary.main;
        }
    };
    // Get the dark color from theme palette for icon
    const getDarkColorFromVariant = (variant) => {
        switch (variant) {
            case "primary":
                return theme.palette.primary.dark;
            case "inherit":
                return theme.palette.action.active;
            case "secondary":
                return theme.palette.secondary.dark;
            case "error":
                return theme.palette.error.dark;
            case "warning":
                return theme.palette.warning.dark;
            case "info":
                return theme.palette.info.dark;
            case "success":
                return theme.palette.success.dark;
            default:
                return theme.palette.primary.dark;
        }
    };
    const mainColor = getMainColorFromVariant(colorVariant);
    const iconColor = getDarkColorFromVariant(colorVariant);
    const backgroundColor = showBackground
        ? alpha(mainColor, alphaValue)
        : "transparent";
    const buttonSx = Object.assign({ color: iconColor, backgroundColor: backgroundColor, "&:hover": {
            backgroundColor: alpha(mainColor, alphaValue + 0.04),
        }, "&:focus": {
            backgroundColor: alpha(mainColor, alphaValue + 0.04),
        } }, sx);
    const IconButtonComponent = (React.createElement(IconButton, Object.assign({}, props, { sx: buttonSx }), children));
    if (title) {
        return (React.createElement(Tooltip, { title: title, arrow: true, placement: "top" }, IconButtonComponent));
    }
    return IconButtonComponent;
};
